import { api } from '@stageplottter/core';
import type { TemplateData } from '@stageplottter/core';
import { listOf } from '../../api/client';
import { getApi } from '../../api/endpoints';

/** Workspace templates (decision U16). */
export function templatesApi() {
  const client = getApi().client;
  const enc = encodeURIComponent;
  return {
    list: (ws: string) =>
      client.get(`/workspaces/${enc(ws)}/templates`, listOf(api.TemplateSummary)),
    get: (id: string) => client.get(`/templates/${enc(id)}`, api.Template),
    create: (ws: string, name: string, data: TemplateData) =>
      client.post(`/workspaces/${enc(ws)}/templates`, { name, data }, api.Template),
    rename: (id: string, name: string) =>
      client.patch(`/templates/${enc(id)}`, { name }, api.TemplateSummary),
    remove: (id: string) => client.delete(`/templates/${enc(id)}`),
  };
}
export type TemplatesApi = ReturnType<typeof templatesApi>;
